import { useT, useI18n } from "@/lib/i18n";

const COPY = {
  de: {
    intro:
      "Was 1968 in Mels als Familienbetrieb begann, ist heute eine der etablierten Adressen für Metallveredelung in der Schweiz. Eine kurze Reise durch die Stationen, die Fritz Kamm AG geprägt haben.",
    milestone: "Meilenstein",
    scroll_hint: "← Horizontal scrollen für die ganze Geschichte →",
    items: [
      { year: "1968", title: "Gründung in Mels", body: "Die Fritz Kamm AG nimmt im Sarganserland den Betrieb auf — als spezialisiertes Galvanik-Unternehmen für die Schweizer Industrie." },
      { year: "1970–80er", title: "Aufbau der Verfahrenspalette", body: "Erweiterung von klassischem Verzinken hin zu Phosphatieren, Brünieren, Vernickeln. Aufbau der Position als Schweizer Galvanik-Adresse." },
      { year: "1990er", title: "Edelstahl-Spezialisierung", body: "CNS-Beizen und CNS-Elektropolieren etablieren sich als Schwerpunkt — Antwort auf wachsende Anforderungen aus Lebensmittel-, Pharma- und Medizintechnik." },
      { year: "ISO 9001", title: "Qualitätsmanagement zertifiziert", body: "Swiss Safety Center Audit. Jeder Prozess dokumentiert, jede Charge nachvollziehbar — die Grundlage für Aufträge in regulierten Branchen." },
      { year: "ISO 14001", title: "Umwelt & CO₂-Reduktion", body: "Systematische Reduktion von CO₂-Emissionen, optimierte Chemiewirtschaft, geschlossene Wasserkreisläufe — Schweizer Verantwortung in Reinform." },
      { year: "2024", title: "Bündelung in Mels", body: "Schließung der Chromwerk AG (St. Gallen) und Übernahme ihrer Leistungen in den Standort Mels — eine Adresse, alle Verfahren." },
      { year: "2025", title: "Heute · 11 Verfahren", body: "Geschäftsführer Marco Mandic. 11 Veredelungsverfahren unter einem Dach. ISO 9001 · ISO 14001. Bereit für die nächsten Jahrzehnte." },
    ],
  },
  en: {
    intro:
      "What began in 1968 in Mels as a family business is today one of Switzerland's established names for metal finishing. A brief journey through the stages that have shaped Fritz Kamm AG.",
    milestone: "Milestone",
    scroll_hint: "← Scroll horizontally for the full story →",
    items: [
      { year: "1968", title: "Founded in Mels", body: "Fritz Kamm AG begins operations in the Sarganserland region — as a specialised electroplating company serving Swiss industry." },
      { year: "1970s–80s", title: "Building the process portfolio", body: "Expansion from classic zinc plating to phosphating, black oxide and nickel plating. Establishing the company as a Swiss electroplating address." },
      { year: "1990s", title: "Stainless-steel specialisation", body: "Stainless-steel pickling and electropolishing become the focus — a response to growing demands from food, pharma and medical technology." },
      { year: "ISO 9001", title: "Quality management certified", body: "Swiss Safety Center audit. Every process documented, every batch traceable — the foundation for orders in regulated industries." },
      { year: "ISO 14001", title: "Environment & CO₂ reduction", body: "Systematic reduction of CO₂ emissions, optimised chemical management, closed-loop water systems — Swiss responsibility in its purest form." },
      { year: "2024", title: "Consolidation in Mels", body: "Closure of Chromwerk AG (St. Gallen) and integration of its services into the Mels site — one address, every process." },
      { year: "2025", title: "Today · 11 processes", body: "Managing Director Marco Mandic. 11 finishing processes under one roof. ISO 9001 · ISO 14001. Ready for the decades ahead." },
    ],
  },
  fr: {
    intro:
      "Ce qui a débuté en 1968 à Mels comme une entreprise familiale est aujourd'hui l'une des références établies de la finition métallique en Suisse. Un bref voyage à travers les étapes qui ont façonné Fritz Kamm SA.",
    milestone: "Étape",
    scroll_hint: "← Faites défiler horizontalement pour voir toute l'histoire →",
    items: [
      { year: "1968", title: "Fondation à Mels", body: "Fritz Kamm SA démarre son activité dans la région de Sarganserland — en tant qu'entreprise spécialisée de galvanoplastie pour l'industrie suisse." },
      { year: "1970–80", title: "Construction du portefeuille de procédés", body: "Élargissement du zingage classique à la phosphatation, au brunissage et au nickelage. Une référence suisse de la galvanoplastie s'établit." },
      { year: "Années 90", title: "Spécialisation inox", body: "Le décapage et le polissage électrolytique de l'inox deviennent l'axe principal — pour répondre aux exigences croissantes de l'agroalimentaire, de la pharmacie et du médical." },
      { year: "ISO 9001", title: "Management qualité certifié", body: "Audit Swiss Safety Center. Chaque procédé documenté, chaque lot traçable — la base des commandes dans les secteurs réglementés." },
      { year: "ISO 14001", title: "Environnement & réduction CO₂", body: "Réduction systématique des émissions de CO₂, gestion chimique optimisée, circuits d'eau fermés — la responsabilité suisse dans sa forme la plus pure." },
      { year: "2024", title: "Consolidation à Mels", body: "Fermeture de Chromwerk SA (St-Gall) et intégration de ses prestations sur le site de Mels — une adresse, tous les procédés." },
      { year: "2025", title: "Aujourd'hui · 11 procédés", body: "Directeur général Marco Mandic. 11 procédés de finition sous un même toit. ISO 9001 · ISO 14001. Prêts pour les décennies à venir." },
    ],
  },
  it: {
    intro:
      "Ciò che è iniziato nel 1968 a Mels come azienda familiare è oggi uno degli indirizzi affermati per la finitura dei metalli in Svizzera. Un breve viaggio attraverso le tappe che hanno plasmato Fritz Kamm SA.",
    milestone: "Tappa",
    scroll_hint: "← Scorri orizzontalmente per l'intera storia →",
    items: [
      { year: "1968", title: "Fondazione a Mels", body: "Fritz Kamm SA avvia l'attività nella regione del Sarganserland — come azienda galvanica specializzata al servizio dell'industria svizzera." },
      { year: "Anni '70–'80", title: "Sviluppo della gamma di procedimenti", body: "Estensione dalla zincatura classica alla fosfatazione, brunitura e nichelatura. Si consolida la posizione come indirizzo svizzero della galvanica." },
      { year: "Anni '90", title: "Specializzazione inox", body: "Decapaggio ed elettrolucidatura dell'inox diventano il fulcro — risposta alle crescenti richieste di alimentare, farmaceutico e medicale." },
      { year: "ISO 9001", title: "Gestione qualità certificata", body: "Audit Swiss Safety Center. Ogni processo documentato, ogni lotto tracciabile — la base per ordini in settori regolamentati." },
      { year: "ISO 14001", title: "Ambiente & riduzione CO₂", body: "Riduzione sistematica delle emissioni di CO₂, gestione chimica ottimizzata, circuiti d'acqua chiusi — responsabilità svizzera in forma pura." },
      { year: "2024", title: "Consolidamento a Mels", body: "Chiusura di Chromwerk SA (San Gallo) e integrazione dei suoi servizi nella sede di Mels — un solo indirizzo, tutti i procedimenti." },
      { year: "2025", title: "Oggi · 11 procedimenti", body: "Direttore generale Marco Mandic. 11 procedimenti di finitura sotto lo stesso tetto. ISO 9001 · ISO 14001. Pronti per i prossimi decenni." },
    ],
  },
};

export const Heritage = () => {
  const t = useT();
  const { lang } = useI18n();
  const c = COPY[lang] || COPY.de;
  return (
    <section
      id="geschichte"
      data-testid="heritage-section"
      className="relative bg-[#0E0E10] py-24 md:py-36 border-t border-white/5 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-10">
          <div className="lg:col-span-5">
            <div className="overline reveal mb-4">{t("sections.geschichte_overline", "— Geschichte · seit 1968")}</div>
            <h2 className="reveal reveal-delay-1 font-display text-4xl sm:text-5xl lg:text-[64px] font-semibold tracking-tight leading-[0.95] text-white">
              {t("sections.geschichte_title_1", "Über fünf Jahrzehnte")}
              <br />
              <span className="text-zinc-500">{t("sections.geschichte_title_2", "Schweizer Galvanik.")}</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="reveal reveal-delay-2 text-zinc-400 text-base md:text-lg leading-relaxed max-w-xl">
              {c.intro}
            </p>
          </div>
        </div>

        <div
          data-testid="heritage-timeline"
          className="relative -mx-6 md:-mx-10 px-6 md:px-10 overflow-x-auto scrollbar-thin"
        >
          <div className="absolute left-0 right-0 top-[46px] h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />

          <ol className="relative flex gap-6 md:gap-8 pb-6 min-w-max items-start">
            {c.items.map((m, i) => (
              <li
                key={m.year}
                data-testid={`heritage-milestone-${i + 1}`}
                className="relative w-[280px] md:w-[320px] flex-none"
              >
                <div className="flex items-end pb-1.5">
                  <div className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-white leading-none">
                    {m.year}
                  </div>
                </div>

                <div className="relative h-5 flex items-center justify-start">
                  <div className="w-2.5 h-2.5 rounded-full bg-white pulse-dot ring-4 ring-[#0E0E10]" />
                </div>

                <div className="border border-white/10 bg-[#121214] hover:bg-[#161618] transition-colors duration-500 p-5 md:p-6">
                  <div className="overline mb-2.5">{c.milestone} {String(i + 1).padStart(2, "0")}</div>
                  <h3 className="font-display text-lg md:text-xl text-white tracking-tight mb-2.5 leading-snug">
                    {m.title}
                  </h3>
                  <p className="text-sm text-zinc-400 leading-relaxed">{m.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="mt-8 text-[12px] text-zinc-500 text-center md:text-left">
          {c.scroll_hint}
        </div>
      </div>
    </section>
  );
};

export default Heritage;
